const NS = 'SearchResultItemWidget';
const CLS = 'searchResultItemWidget';

export class SearchResultItemWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$close = this.$element.find(`.close`);
		this.videoSrc = this.$element.find(`.${CLS}-openVideo .videobtn`).data('videosrc');

		this.$iframe = this.$element.find(`.modal iframe`);
		this.$modal = this.$element.find(`.modal`);
		
		$(this.$close).on('click', (e) => {
			e.preventDefault();
			$(this.$iframe).attr('src', '');
			$(this.$iframe).attr('src', this.videoSrc);
		});

		$(this.$modal).on('click', (e) => {
			e.preventDefault();
			$(this.$iframe).attr('src', '');
			$(this.$iframe).attr('src', this.videoSrc);
		});
	}
}
